<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">

    <v-layout row class="sports-bookmarks">
      <v-flex xs12>
        <bookmarkcards :bookmarks="sportsBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
    </v-layout>
    
    <v-layout row>
      <v-flex xs12>
        <newscards newsSource="espn"></newscards>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <newscards newsSource="nfl-news"></newscards>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import dataApi from '../services/ApiService'

export default {
  name: 'Sports',
  data: () => ({
      loading: false,
      is_data_fetched: false,
      sportsBookmarks: []
  }),
  methods: {
    getDataFile() {
      dataApi.fetchDataFile ('sports-bookmarks.json')
      .then(response => {
        if (Object.keys(response).length) {
          this.sportsBookmarks = response.bookmarkList
          this.is_data_fetched = true
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })

    }
  },
  mounted () {
    this.getDataFile()
  }
}
</script>


<style lang="scss">
</style>